import SickLeave from '../components/Sickleave'
const SickLeaves = () => {
  return (
    <>   
    <SickLeave/>
    </>
  )
}

export default SickLeaves